import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Styles from "../../../Styles/Analyst/TraderSelection.module.css";

import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import OutlinedInput from "@mui/material/OutlinedInput";
import analystService from "../../../components/Services/analyst.service";
import { getSpeceficTraders, getSpeceficTradersNew } from "../../../store/Analyst/action";
import { Checkbox, ListItemText } from "@mui/material";

const MenuProps = {
  PaperProps: {
    style: {
      outline: "0px",
      border: "0px",
    },
  },
};

function getStyles() {
  return {
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "20px",
  };
}

const Trader = ({ userDetails }) => {
  const companyId = userDetails?.companyId;
  const trader = useSelector((state) => state?.analystReducer);
  const dispatch = useDispatch();

  const [selectedTrader, setSelectedTrader] = useState([]);
  const [viewSubmit, setViewSubmit] = useState(false);

  useEffect(() => {
    if (selectedTrader?.length === 0) {
      checkTrader();
    }
  }, [trader?.companyTraders]);

  const checkTrader = () => {
    trader?.companyTraders?.map((ele) => {
      let payload = {
        id: ele?.id,
        selectedTrader: true,
        companyId: companyId,
      };

      setSelectedTrader((prev) => [...prev, payload]);
    });
  };

  const handleAddTrader = async (event) => {
    let res = await analystService.getUpdateTraderCompany(selectedTrader);
    if (res?.data?.code === 200) {
      getSpeceficTradersNew(companyId)(dispatch);
      setViewSubmit(false);
    }
  };

  const handleAlterTrader = async (event) => {
    setViewSubmit(true);
    const {
      target: { value },
    } = event;
    if (selectedTrader?.filter((ele) => ele?.id === value)?.length > 0) {
      let index = selectedTrader?.findIndex((ele) => ele?.id === value);
      handleRemoveTrader(value, index);
    } else {
      let payload = { id: value, selectedTrader: true, companyId: companyId };
      setSelectedTrader((prev) => [...prev, payload]);
    }
  };

  const handleRemoveTrader = (id, index) => {
    let newRes = selectedTrader?.filter((ele) => ele?.id !== id);
    setSelectedTrader(newRes);
  };

  return (
    <div className={Styles.traderSelContianer}>
      <div className={Styles.traderAllSelected}>
        <Select
          style={{ height: "100%", width: "100%", borderRadius: "8px" }}
          displayEmpty
          onChange={handleAlterTrader}
          input={<OutlinedInput />}
          renderValue={(selected) => {
            if (selected?.length === 0) {
              return <em>Status</em>;
            }
            return (
              <em>{`Add or Remove trader to ${userDetails?.companyName}`}</em>
            );
          }}
          MenuProps={MenuProps}
          inputProps={{ "aria-label": "Without label" }}
        >
          <MenuItem disabled value="">
            <em>Trader List</em>
          </MenuItem>
          {trader?.allTraders?.map((ele) => (
            <MenuItem key={ele?.id} value={ele?.id} style={getStyles()}>
              <Checkbox
                checked={
                  selectedTrader?.filter((c) => c?.id === ele?.id)?.length > 0
                }
              />
              <ListItemText primary={ele?.userName} />
            </MenuItem>
          ))}
        </Select>
      </div>
      {viewSubmit && (
        <div className={Styles.submitButton} onClick={handleAddTrader}>
          Submit
        </div>
      )}
      <div>
        {trader?.companyTraders?.length === 0 ? (
          <div className={Styles.traderSelEmpty}>
            There is no trader assigned{" "}
            <b>Please Assign trader to {userDetails?.companyName}</b>
          </div>
        ) : (
          <>
            <div className={Styles.traderHeading}>
              <div>UserName</div>
              <div>Email</div>
              <div>Intra State</div>
              <div>Inter State</div>
            </div>
            <div>
              {trader?.companyTraders?.map((ele) => (
                <div className={Styles.traderDetails}>
                  <div>{ele?.userName}</div>
                  <div>{ele?.email}</div>
                  <div>{!ele?.isInterstate ? "Yes" : "No"}</div>
                  <div>{ele?.isInterstate ? "Yes" : "No"}</div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Trader;
